import { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Services from './components/Services';
import Stats from './components/Stats';
import About from './components/About';
import Process from './components/Process';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const getThemeByTime = () => {
    const h = new Date().getHours();
    return (h >= 18 || h < 6) ? 'dark' : 'light';
  };
  const [theme, setTheme] = useState(getThemeByTime);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Global scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) {
          const delay = e.target.dataset.delay || 0;
          setTimeout(() => e.target.classList.add('revealed'), Number(delay));
          observer.unobserve(e.target);
        }
      }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <div className="App">
      {/* Animated aurora background */}
      <div className="aurora" aria-hidden="true">
        <div className="aurora-blob aurora-blob--1" />
        <div className="aurora-blob aurora-blob--2" />
        <div className="aurora-blob aurora-blob--3" />
      </div>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <Hero />
      <Marquee />
      <Services />
      <Stats />
      <About />
      <Process />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
